import { render, staticRenderFns } from "./builder-test.vue?vue&type=template&id=028700f1"
import script from "./builder-test.vue?vue&type=script&lang=js"
export * from "./builder-test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports